// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__17uQ3","info":"UpdateTermsInfo_info__26P1h"};